import { STORAGE_KEYS } from "../app_constants";

/** Favorited animation-preset ids, persisted to localStorage. */
export const loadFavorites = (): Set<string> => {
  try {
    const raw = localStorage.getItem(
      STORAGE_KEYS.LOCAL_STORAGE_ANIMATION_FAVORITES,
    );
    const parsed = raw ? JSON.parse(raw) : [];
    return new Set(
      Array.isArray(parsed)
        ? parsed.filter((id) => typeof id === "string")
        : [],
    );
  } catch {
    // corrupt JSON or storage unavailable (private mode) — start empty
    return new Set();
  }
};

export const saveFavorites = (favorites: Set<string>) => {
  try {
    localStorage.setItem(
      STORAGE_KEYS.LOCAL_STORAGE_ANIMATION_FAVORITES,
      JSON.stringify([...favorites]),
    );
  } catch {
    // storage full/unavailable — favorites just won't persist this session
  }
};

export const toggleFavorite = (
  favorites: Set<string>,
  presetId: string,
): Set<string> => {
  const next = new Set(favorites);
  if (next.has(presetId)) {
    next.delete(presetId);
  } else {
    next.add(presetId);
  }
  saveFavorites(next);
  return next;
};
